import { render, staticRenderFns } from "./case-verify.vue?vue&type=template&id=0372856c"
import script from "./case-verify.vue?vue&type=script&lang=ts"
export * from "./case-verify.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports